import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Spinner, EmptyState } from "../components/common";
import api from "../lib/api";
import { fmtTime } from "../lib/format";

export default function Messages() {
  const navigate = useNavigate();
  const [convs, setConvs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = () => api.get("/chat/conversations").then((r) => setConvs(r.data)).finally(() => setLoading(false));
    load();
    const id = setInterval(load, 8000);
    return () => clearInterval(id);
  }, []);

  if (loading) return <Spinner />;

  return (
    <div className="space-y-4 max-w-2xl">
      <h1 className="font-heading font-extrabold text-2xl text-navy">Messages</h1>
      {convs.length === 0 ? (
        <EmptyState icon={MessageCircle} title="Belum ada pesan" subtitle="Percakapan dengan BAWAINER/TITIPER akan muncul di sini." />
      ) : (
        <div className="space-y-2">
          {convs.map((c) => (
            <button key={c.id} onClick={() => navigate(`/chat/${c.id}`)} data-testid={`conv-${c.id}`}
              className="w-full flex items-center gap-3 bg-white rounded-2xl p-3 shadow-soft border border-black/5 text-left hover:bg-cloud transition-colors">
              <img src={c.other?.avatar} alt="" className="w-12 h-12 rounded-2xl object-cover" />
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <span className="font-heading font-bold text-navy truncate">{c.other?.name}</span>
                  <span className="text-[11px] text-muted-foreground">{fmtTime(c.updated_at)}</span>
                </div>
                <div className="text-sm text-muted-foreground truncate">{c.last_message || "Mulai percakapan"}</div>
              </div>
              {c.unread > 0 && <span className="w-5 h-5 rounded-full bg-lime text-navy text-[11px] font-bold flex items-center justify-center">{c.unread}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
